import React from 'react';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';

// Lab variant → MDS appearance + variant.
const VARIANTS = {
  primary: { appearance: 'primary', variant: 'filled' },
  secondary: { appearance: 'secondary', variant: 'filled' },
  outline: { appearance: 'neutral', variant: 'outlined' },
  text: { appearance: 'neutral', variant: 'plain' },
};

/**
 * Shared Lab button, rendered as an MDS `mc-button`.
 * Same props as before; `icon` may be an MDS icon name (string) or a React node.
 */
const MaerskButton = ({
  children,
  onClick,
  variant = 'primary', // primary, secondary, outline, text
  size = 'medium', // small, medium, large
  disabled = false,
  fullWidth = false,
  type = 'button',
  loading = false,
  icon = null
}) => {
  const { appearance, variant: mdsVariant } = VARIANTS[variant] || VARIANTS.primary;
  const inactive = disabled || loading;

  return (
    <McButton
      type={type}
      appearance={appearance}
      variant={mdsVariant}
      fit={size}
      width={fullWidth ? 'full-width' : 'auto'}
      disabled={inactive}
      loading={loading}
      icon={typeof icon === 'string' ? icon : undefined}
      click={inactive ? undefined : onClick}
    >
      {icon && typeof icon !== 'string' && !loading && <span slot="icon">{icon}</span>}
      {children}
    </McButton>
  );
};

export default MaerskButton;
